import { DEFAULT_HIT_PADDING, type HitAreaOptions } from './HitArea';

/** Field values a {@link Draggable} can be built with. Omitted fields keep their default. */
export type DraggableOptions = HitAreaOptions;

/**
 * Marks an entity as something the pointer can pick up and move.
 *
 * Pure data, for the same reason {@link Clickable} is: the system finds what was grabbed and reports
 * how far it moved, and a behavior decides what that means. A drag that moves the entity is
 * `DragToMove`; a drag that scrubs a slider is a game's own behavior reading the same events.
 *
 * Independent of {@link Clickable}. An entity may be either, both or neither, and a drag that moves
 * does not suppress the click, so a tap on a draggable still reads as a tap.
 */
export class Draggable {
  /** Whether the entity can be picked up. A disabled draggable is invisible to hit-testing. */
  enabled: boolean;
  /** Extra world units of hit area on every side. */
  padding: number;

  constructor(options: DraggableOptions = {}) {
    this.enabled = options.enabled ?? true;
    this.padding = options.padding ?? DEFAULT_HIT_PADDING;
  }
}
